class CustomSlider {
  constructor(selector) {
    this.valueCustomSliders = document.querySelectorAll(selector);

    if (!this.valueCustomSliders.length) return;

    this.tabs = document.querySelectorAll(".value-custom-tab");
    this.sliders = document.querySelectorAll(".value-custom-slider");
    this.cursors = document.querySelectorAll(".value-custom-cursor");
    this.arrowsContainersMobile = document.querySelectorAll(".value-custom-arrows-mobile");

    this.flickityInstances = new Map();

    this.init();
  }

  init() {
    this.valueCustomSliders.forEach((slider) => {
      this.setupSlider(slider);
    });

    this.setupTabListeners();

    this.setupCursorListeners();
  }

  setupSlider(slider) {
    const tabId = slider.dataset.tabId;
    const cursorContainer = slider.parentElement.querySelector(
      `.value-custom-cursor[data-tab-id="${tabId}"]`
    );
    const arrowsContainerMobile = slider.parentElement.querySelector(
      `.value-custom-arrows-mobile[data-tab-id="${tabId}"]`
    );

    if (!this.flickityInstances.has(tabId)) {
      const wasHidden = !slider.classList.contains("active");
      if (wasHidden) {
        slider.style.display = "block";
        slider.style.visibility = "hidden";
      }

      const flkty = new Flickity(slider, {
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        autoPlay: false,
      });

      flkty.on("change", (index) => {
        const activeSlide = slider.querySelectorAll(".value-custom-slide")[
          index
        ];
        const slideTitle = activeSlide.dataset.slideTitle;
        const tooltipText = cursorContainer.querySelector(
          ".value-custom-tooltip-text"
        );
        if (tooltipText && slideTitle) {
          tooltipText.textContent = slideTitle;
        }
      });

      this.flickityInstances.set(tabId, flkty);

      if (wasHidden) {
        slider.style.display = "";
        slider.style.visibility = "";
      }

      this.updateArrowsPosition(slider, cursorContainer, arrowsContainerMobile);
    }
  }

  setupTabListeners() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.handleTabClick(tab));
    });
  }

  setupCursorListeners() {
    this.cursors.forEach((cursor) => {
      cursor.addEventListener("mouseenter", () => {
        if (cursor.classList.contains("active")) {
          cursor.classList.add("show-details");
        }
      });
    });

    document.addEventListener("click", (event) => {
      const activeSlider = document.querySelector(
        ".value-custom-slider.active"
      );
      const activeCursor = document.querySelector(
        ".value-custom-cursor.active"
      );
     

      if (activeSlider && activeCursor) {
        if (
          !activeSlider.contains(event.target) &&
          !activeCursor.contains(event.target)
        ) {
          activeCursor.classList.remove("show-details");
        }
      }
    });
  }

  updateArrowsPosition(slider, cursorContainer, arrowsContainerMobile) {
    const prevButton = slider.querySelector(
      ".flickity-prev-next-button.previous"
    );
    const nextButton = slider.querySelector(".flickity-prev-next-button.next");

    const arrowsContainer = cursorContainer.querySelector(
      ".value-custom-arrows"
    );

    const currentContainer = window.innerWidth > 768 ? arrowsContainer : arrowsContainerMobile;
    
    currentContainer.appendChild(prevButton);
    currentContainer.appendChild(nextButton);
  }

  handleTabClick(clickedTab) {
    const tabId = clickedTab.dataset.tabId;

    this.tabs.forEach((tab) => tab.classList.remove("active"));
    this.sliders.forEach((slider) => slider.classList.remove("active"));
    this.cursors.forEach((cursor) => cursor.classList.remove("active"));
    this.arrowsContainersMobile.forEach((container) => container.classList.remove("active"));

    clickedTab.classList.add("active");

    const matchedSlider = document.querySelector(
      `.value-custom-slider[data-tab-id="${tabId}"]`
    );
    if (matchedSlider) {
      matchedSlider.classList.add("active");
      this.setupSlider(matchedSlider);

      const flickityInstance = this.flickityInstances.get(tabId);
      if (flickityInstance) {
        setTimeout(() => {
          flickityInstance.resize();
        }, 10);
      }
    }

    const matchedCursor = document.querySelector(
      `.value-custom-cursor[data-tab-id="${tabId}"]`
    );
    if (matchedCursor) {
      matchedCursor.classList.add("active");
    }

    const matchedArrowsContainerMobile = document.querySelector(
      `.value-custom-arrows-mobile[data-tab-id="${tabId}"]`
    );
    if (matchedArrowsContainerMobile) {
      matchedArrowsContainerMobile.classList.add("active");
    }
  }
}

const customSlider = new CustomSlider(".value-custom-slider");
